<script>
export default {
  props: {
    // it's array of strings
    value: {
      type: Array,
      default: () => [],
    },
    transform: {
      type: Function,
      default: (item) => item,
    },
  },
  computed: {
    content() {
      return this.value ? this.value.join('\n') : '';
    },
  },
  methods: {
    onInput(e) {
      e.preventDefault();
      const data = e.target.value.trim().split('\n').map(val => this.transform(val));
      if (e.inputType === 'insertLineBreak') {
        data.push('');
      }
      this.$emit('input', data);
    },
  },
};
</script>

<template>
  <textarea :value="content" @input="onInput"></textarea>
</template>
